// extracted by mini-css-extract-plugin
export var navbarSubLink = "G_f6 d_f6 d_f0 d_X d_b8 d_dj d_bp d_bQ";
export var menuLink = "G_vc d_fX d_dx";
export var subPageLink = "G_gb d_gb d_dn d_dr";
export var subPageLinkColor = "G_gc d_gc";
export var burgerItemSmall = "G_vd d_f9 d_W d_bq";
export var Link = "G_sr x_sr x_rM x_r5";